<template>
  <v-row justify="center">
    <v-col cols="12" sm="7" md="4">
      <v-card
        :flat="isMobile"
        :color="isMobile ? '' : 'companyTertiary'"
        max-width="500"
      >
        <v-card-title :class="{ 'white--text': !isMobile }">
          Thank you!
        </v-card-title>
        <v-card-subtitle :class="{ 'white--text': !isMobile }">
          Your profile has been registered in our platform.
        </v-card-subtitle>
        <v-card-text class="white text--primary pa-5">
          To complete your signup process, please open the confirmation e-mail
          that we just sent you, and click on the link.
        </v-card-text>
        <v-card-text class="white text--primary py-5 pb-5 pt-0">
          If you do not receive our confirmation e-mail in the next two hours,
          please
          <a :href="`mailto:${getLegalEntity.recruitmentMail}`">contact us</a>.
        </v-card-text>
        <v-card-actions class="white">
          <v-spacer />
          <v-btn block color="primary" :to="{ name: 'login' }">
            Back To Login
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "RegistrationThankYouView",
  computed: {
    ...mapGetters("domain", ["getLegalEntity"]),
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
  },
};
</script>
